import { Navigate } from "react-router-dom";
import ApprovalManagement from "./pages/approval";
import AccountClosure from "./pages/closures";
import AccountClosureDetail from "./pages/closure-detail";
import PermissionGuard from "@/guards/permission-guard";
import { CAPABILITIES } from "@/config/permissions";

const ApprovalRoutes = [
  {
    path: "/approvals",
    children: [
      { index: true, element: <Navigate to="report" replace /> },
      { path: "report", element: <ApprovalManagement /> },
      {
        path: "closure-request",
        element: (
          <PermissionGuard capability={CAPABILITIES.CLOSURE_REVIEW}>
            <AccountClosure />
          </PermissionGuard>
        ),
      },
      {
        path: "closure-request/:id",
        element: (
          <PermissionGuard capability={CAPABILITIES.CLOSURE_REVIEW}>
            <AccountClosureDetail />
          </PermissionGuard>
        ),
      },
    ],
  },
];

export default ApprovalRoutes;